import React, { useState, useRef, useEffect, useContext } from "react";
import {
  MapContainer as Map,
  TileLayer,
  Marker,
  Popup,
  useMapEvents,
} from "react-leaflet";
import L from "leaflet";
import "../styles/addPost.css";
import { mapConfig } from "../helper/mapConfig";
import { useNavigate } from "react-router";
import { profileUser } from "../api/service";
import Navbar from "../components/Navbar";
import TextBox from "../components/TextBox";
import TextArea from "../components/TextArea";
import Footer from "../components/Footer";
import { TbConfetti } from "react-icons/tb";
import {
  BiCurrentLocation,
  BiBold,
  BiItalic,
  BiStrikethrough,
} from "react-icons/bi";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import firebase from "firebase/compat/app"; // Import only the necessary Firebase module
import "firebase/messaging"; // Import the messaging module if needed
import { firebaseConfig } from "../firebase"; // Adjust the path accordingly
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Axios from "axios";
// import { MapPinIcon } from "@heroicons/outline";
import { FaLocationArrow, FaEdit } from "react-icons/fa";
import * as turf from "@turf/turf";

const API_KEY = "e9d8379d202a0ab45e4395390d3e5fa2";
const api_endpoint = `https://api.openweathermap.org/geo/1.0/reverse?`;

const markerIcon = new L.Icon({
  iconUrl: require("../assets/markerIcon.png"),
  iconSize: [40, 35],
  iconAnchor: [17, 46], //[left/right, top/bottom]
  popupAnchor: [0, -46], //[left/right, top/bottom]
});

// Define the boundary of India as a GeoJSON feature

const poly = turf.polygon([
  [
    [68.176645, 7.965535],
    [97.402561, 7.965535],
    [97.402561, 35.504475],
    [68.176645, 35.504475],
    [68.176645, 7.965535],
  ],
]);

function isPointInIndia(latitude, longitude) {
  console.log(latitude, longitude);
  const point = turf.point([longitude, latitude]);
  const isInsideIndia = turf.booleanPointInPolygon(point, poly);
  return isInsideIndia;
}

function LocationMarker({ position, setPosition, marker, setMarker }) {
  const map = useMapEvents({
    click(e) {
      const { latlng } = e;
      if (marker) {
        map.removeLayer(marker);
      }
      console.log(latlng);
      console.log("india");
      // console.log(position.lat)
      if (isPointInIndia(latlng.lat, latlng.lng)) {
        console.log("in india");
        const newMarker = L.marker(latlng, { icon: markerIcon }).addTo(map);
        setPosition(latlng);
        console.log(latlng);
        setMarker(newMarker);
        map.flyTo(latlng, map.getZoom());
      } else {
        setPosition(null);
        setMarker(null);
      }
      console.log("jjjjjjjjjjjjjjjjjjj");
      console.log(position);
    },
    locationfound(e) {
      setPosition(e.latlng);
      map.flyTo(e.latlng, 15);
    },
  });

  useEffect(() => {
    if (position && marker) {
      marker.setLatLng(position);
    }
  }, [marker]);

  return position === null ? null : (
    <Marker position={position} icon={markerIcon}>
      <Popup>
        <div style={{ display: "flex", margin: 0, justifyContent: "center" }}>
          <BiCurrentLocation size={16} /> You Are Here
        </div>
      </Popup>
    </Marker>
  );
}

const AddPost = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [isBold, setIsBold] = useState(false);
  const [isItalic, setIsItalic] = useState(false);
  const [isStrikethrough, setIsStrikethrough] = useState(false);
  const [step, setStep] = useState(1);

  let token = localStorage.getItem("token");
  const navigate = useNavigate();
  const profileInit = () => {
    profileUser(token).then((req, res) => {
      console.log(req.data);
      if (req.data.status !== "failed") {
        console.log(req.data);
      } else {
        navigate("/");
      }
    });
  };
  const [selectedFile, setSelectedFile] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [image, setImage] = useState("");

  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (event) => {
      setImage(event.target.result);
    };
    reader.readAsDataURL(file);
    setSelectedFile(file); // Set the selected file
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();

    // const reader = new FileReader();
    // reader.onload = async () => {
    //   const fileData = new Uint8Array(reader.result); // Get the file data as Uint8Array
    //   console.log(fileData);
    let token = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("post", selectedFile);
    formData.append("title", title);
    formData.append("description", description);
    formData.append("lat", position.lat);
    formData.append("lng", position.lng);
    formData.append("city", city);
    formData.append("state", state);
    formData.append("country", country);
    formData.append("category", selectedCategory);
    formData.append("isScraped", false);
    setTitle("");
    setDescription("");
    setCity("");
    setState("");
    setCountry("");
    setSelectedCategory("");
    setSelectedFile(null);
    const config = {
      headers: {
        authorization: token,
        "Content-Type": "multipart/form-data",
      },
    };
    Axios.post(
      process.env.REACT_APP_API_BASE_URL + "/api/posts/save",
      formData,
      config
    )
      .then((res) => {
        // setshowloader(false)() =>
        setShowModal(true);
        console.log("Image uploaded successfully:", res.data.imageUrl);
        alert("News has been posted successfully!");
      })
      .catch((err) => console.log(err));
    // };

    // reader.readAsArrayBuffer(selectedFile);

    const initializeFirebase = async () => {
      try {
        if (!firebase.apps.length) {
          firebase.initializeApp(firebaseConfig);
        }

        navigator.serviceWorker
          .register("/firebase-messaging-sw.js")
          .then((registration) => {
            console.log(
              "Service Worker registered with scope:",
              registration.scope
            );
          })
          .catch((error) => {
            console.error("Error registering Service Worker:", error);
          });
      } catch (error) {
        console.error("Error initializing Firebase messaging:", error);
      }
    };
    const messaging = firebase.messaging();
    initializeFirebase();
    console.log("Firebase initialized");

    try {
      const response = await Axios.post(
        process.env.REACT_APP_API_BASE_URL + "/api/send-push-notifications",
        {
          postData: {
            lat: position.lat,
            lng: position.lng,
            title: title,
            desc: description,
          },
        }
      );

      console.log("Push notifications response:", response.data);
      if (response.data.notificationResponses) {
        // Iterate through the notification responses and display notifications
        response.data.notificationResponses.forEach((messageId, index) => {
          console.log("Notification Message ID:", messageId);

          // Display notification using toast library
          toast.info(title, {
            onClick: () => {
              // Handle the click event if needed (e.g., navigate to a specific page)
              console.log("Notification clicked!");
            },
          });
        });
      }
    } catch (error) {
      // Handle errors
      console.error("Error making push notifications request:", error);
    }
  };

  const [center, setCenter] = useState({
    lat: 21.567545592626146,
    lng: 79.11035209894182,
  });
  const ZOOM_LEVEL = 4;
  const mapRef = useRef(null);
  const [marker, setMarker] = useState(null);
  const [position, setPosition] = useState(null); // New state for position
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("Algae growth");

  const addMarkerAtCurrentLocation = async () => {
    if (marker) {
      mapRef.current.removeLayer(marker);
    }
    await mapRef.current.locate();
    // console.log(position);
  };

  useEffect(() => {
    if (!position) return;

    Axios.get(
      `${api_endpoint}lat=${position.lat}&lon=${position.lng}&limit=1&appid=${API_KEY}`
    )
      .then((res) => {
        console.log(res.data);
        setCity(res.data[0].name);
        setState(res.data[0].state);
        setCountry(res.data[0].country);
      })
      .catch((err) => console.log(err));
  }, [position]);

  useEffect(() => {
    profileInit();
  }, []);

  const handleButtonClick = (post) => {
    // First, navigate to the desired URL
    navigate("/posts" + post._id);
    setShowModal(true);
  };

  const textAreaClassName = `text-md dark:text-[#c9d1d9] text-[#161b22] ${
    isBold ? "font-bold" : ""
  } ${isItalic ? "italic" : ""} ${isStrikethrough ? "line-through" : ""}`;

  
  return (
    <>
      <Navbar />
      <div className=" dark:bg-[#010409] bg-[#FAF7F0]">
        <form
          encType="multipart/form-data"
          onSubmit={handleFormSubmit}
          className="flex flex-col items-center pt-20 "
        >
          <div className="w-full max-w-xl p-6 bg-white dark:bg-gray-700 rounded-lg shadow-lg">
            <div className="text-center">
              <h1 className="mb-4 text-3xl font-bold text-gray-800 dark:text-gray-100">
                Post News
              </h1>
              <div className="w-full h-1 mx-auto mb-4 bg-blue-500 dark:bg-blue-300 rounded-full"></div>
              <div className="text-sm font-semibold text-gray-500 dark:text-gray-400">
                Step {step} of 4
              </div>
            </div>
            <div className="flex flex-col space-y-4">
              {step === 1 && (
                <div className="flex flex-col space-y-4">
                  <div className="w-1/3 h-2 mx-auto mt-1 mb-6 bg-gray-200 dark:bg-gray-600 rounded-full">
                    <div className="w-1/4 h-full text-center text-white bg-green-600 dark:bg-green-400 rounded-full"></div>
                  </div>
                  <label className="text-sm font-semibold text-gray-600 dark:text-gray-300">
                    Upload an Image
                  </label>
                  <div className="relative bg-gray-100 dark:bg-gray-600 border rounded-lg">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleFileInputChange}
                      className="absolute inset-0 w-full h-full p-4 opacity-0 cursor-pointer"
                    />
                    {image ? (
                      <div className="w-full h-64">
                        <img
                          src={image}
                          alt="Selected"
                          className="object-cover w-full h-full"
                        />
                      </div>
                    ) : (
                      <img
                        src="https://api.iconify.design/solar:gallery-send-outline.svg?color=%23525252"
                        alt="Upload"
                        className="w-40 h-40 m-auto"
                      />
                    )}
                  </div>
                </div>
              )}
              {step === 2 && (
                <div className="flex flex-col ">
                  <div className="w-1/3 h-2 mx-auto mt-1 mb-6 bg-gray-200 dark:bg-gray-600 rounded-full">
                    <div className="w-2/4 h-full text-center text-white bg-green-600 dark:bg-green-400 rounded-full"></div>
                  </div>
                  {image && (
                    <div className="flex items-center justify-center m-auto">
                      <img
                        src={image}
                        alt="Selected"
                        className="object-fit w-1/3"
                      />
                    </div>
                  )}

                  <label className="text-sm font-semibold text-gray-600 dark:text-gray-300 text-start">
                    News Title
                  </label>
                  <input
                    type="text"
                    name="name"
                    onChange={(e) => setTitle(e.target.value)}
                    required
                    className="w-full mb-4 px-2 py-2 text-gray-700 border rounded-lg focus:outline-none focus:border-indigo-500 dark:bg-gray-700 dark:text-white"
                  />
                  <label className="text-sm font-semibold text-gray-600 dark:text-gray-300 text-start">
                    News Description
                  </label>
                  <textarea
                    name="description"
                    onChange={(e) => setDescription(e.target.value)}
                    required
                    className="w-full px-2 py-2 text-gray-700 border rounded-lg focus:outline-none focus:border-indigo-500 dark:bg-gray-700 dark:text-white"
                  />
                </div>
              )}

              {step === 3 && (
                <div className="flex flex-col space-y-4">
                  <div className="w-1/3 h-2 mx-auto mt-1 mb-6 bg-gray-200 dark:bg-gray-600 rounded-full">
                    <div className="h-full text-center text-white bg-green-600 dark:bg-green-400 rounded-full w-3/4"></div>
                  </div>

                  <div className="flex justify-center">
                    <div className="relative inline-block w-3/4 mb-4 sm:w-5/12">
                      <label className="text-sm font-semibold text-gray-600 dark:text-gray-300 text-start">
                        Select Category
                      </label>
                      <select
                        value={selectedCategory}
                        onChange={(e) => setSelectedCategory(e.target.value)}
                        className="block appearance-none w-full dark:bg-[#0d1117] dark:border-[#161b22] border-2 dark:text-[#d7dfe7]  bg-[#e6e4e1] text-[#161b22] py-3 px-3 md:px-4 pr-8 rounded-md leading-tight focus:outline-none "
                      >
                        <option value="Algae growth">Algae growth</option>
                        <option value="Flash Flood">Flash Flood</option>
                        <option value="Waterlogging">Waterlogging</option>
                        <option value="Pipeline damage">Pipeline damage</option>
                        <option value="Clogged drain">Clogged drain</option>
                        <option value="Industrial Waste">
                          Industrial Waste
                        </option>
                        <option value="Garbage Disposal">
                          Garbage Disposal
                        </option>
                      </select>
                      <div className="absolute inset-y-0 right-0 flex items-center pr-4 text-black dark:text-white pointer-events-none">
                        <img
                          src="https://api.iconify.design/gg:arrows-v.svg?color=%231c1c1c"
                          alt="arrow"
                          className="w-4 h-4"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {step === 4 && (
                <div className="flex flex-col space-y-4 w-full">
                  <div className="w-1/3 h-2 mx-auto mt-1 mb-6 bg-gray-200 dark:bg-gray-600 rounded-full">
                    <div className="w-4/4 h-full text-center text-white bg-green-600 dark:bg-green-400 rounded-full"></div>
                  </div>
                  <label className="text-sm font-semibold text-gray-600 dark:text-gray-300">
                    Set Location
                  </label>
                  <button
                    type="button"
                    className=" px-4 py-2 font-medium text-white bg-[#3B7BD3] border rounded-lg shadow-none focus:outline-none hover:bg-[#3B7BD3]/80 w-1/3 m-auto text-center"
                    onClick={addMarkerAtCurrentLocation}
                  >
                    <div
                      style={{
                        display: "flex",
                        margin: 0,
                        justifyContent: "center",
                      }}
                    >
                      <FaLocationArrow className="mt-1" size={16} /> &nbsp;
                      Locate
                    </div>
                    {/* <MapPinIcon class="h-6 w-6 text-gray-500" /> */}
                    {/* <UilMapPin size ="30" color="#ffffff" className="flex ml-6"/> */}
                  </button>
                  <div className="z-0  text-center">
                    <div className="flex flex-col items-center">
                      <Map
                        center={center}
                        zoom={ZOOM_LEVEL}
                        ref={mapRef}
                        className="rounded-lg shadow-2xl shadow-gray-500 w-full"
                      >
                        <TileLayer
                          url={mapConfig.maptiler.url}
                          attribution={mapConfig.maptiler.attribution}
                        />
                        <LocationMarker
                          position={position}
                          setPosition={setPosition}
                          marker={marker}
                          setMarker={setMarker}
                        />
                      </Map>
                      {/* <button onClick={() => console.log(position)}>Position</button> */}
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="flex justify-between mt-8">
              {step > 1 && (
                <button
                  onClick={() => setStep(step - 1)}
                  className="px-4 py-2 font-medium text-gray-500 bg-transparent rounded-lg shadow-none hover:text-gray-700 dark:text-gray-300"
                >
                  Previous
                </button>
              )}
              {step < 4 && (
                <button
                  onClick={() => setStep(step + 1)}
                  className="px-4 py-2 font-medium text-white bg-[#3B7BD3] border rounded-lg shadow-none focus:outline-none hover:bg-[#3B7BD3]/80"
                >
                  Next &nbsp; &rarr;
                </button>
              )}
              {step === 4 && (
                <button
                  className="px-4 py-2 font-medium text-white bg-green-600 border rounded-lg shadow-none focus:outline-none hover:bg-green-700 dark:bg-green-400"
                  type="submit"
                >
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <FaEdit size={25} /> &nbsp; Post
                  </div>
                </button>
              )}
            </div>
          </div>
          {/* <div className="relative inline-block w-3/4 mb-4 sm:w-5/12">
            <label className="block appearance-none w-full dark:bg-[#0d1117] border-[#888989] dark:border-[#161b22] border-2 dark:text-[#0d1117] bg-[#FAF7F0] text-[#161b22] py-3 px-3 md:px-4 pr-8 rounded-md leading-tight focus:outline-none  ">
              <span className="dark:text-[#d7dfe7] text-[#161b22] pl-11 font-semibold text-lg">
                Upload Image :{" "}
              </span>
              <input
                type="file"
                onChange={handleFileInputChange}
                className="mt-1 w-3/5 font-semibold text-[#161b22] dark:text-[#d7dfe7] dark:bg-[#0d1117] bg-[#FAF7F0]"
              />
            </label>
          </div> */}

          {showModal ? (
            <>
              <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
                <div className="relative max-w-3xl mx-auto my-6 md:w-80">
                  {/*content*/}
                  <div className="border-[#161b22] border-2 rounded-lg relative flex flex-col w-full bg-[#0D1117] ">
                    {/*header*/}
                    <div className="flex items-center justify-center  h-16 p-2 border-b border-solid border-[#d7dfe7] rounded-t">
                      <h3 className="text-2xl uppercase text-[#d7dfe7] font-semibold">
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <TbConfetti size={25} /> &nbsp; Congratulations
                        </div>
                      </h3>
                    </div>
                    {/*body*/}
                    <div className="relative flex-auto">
                      <p className="my-4 text-[#d7dfe7] text-lg leading-relaxed font-semibold">
                        Post Created Successfully!
                      </p>
                    </div>
                    {/*footer*/}
                    <div className="flex items-center justify-center p-6 ">
                      <button
                        className="shadow-none text-[#d7dfe7] bg-[#1f7e30] hover:bg-[#2ea043] font-bold py-2 px-2  rounded-md h-10 w-32  ease-linear transition-all duration-500"
                        type="button"
                        onClick={() => navigate("/posts")}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="fixed inset-0 z-40 bg-gray-700 opacity-90"></div>
            </>
          ) : null}
        </form>
        <Footer />
      </div>
    </>
  );
};

export default AddPost;
